module.exports = __webpack_public_path__ + "static/media/agtrac.b636192c.jpg";